import { render, staticRenderFns } from "./LocaisSepultamento.vue?vue&type=template&id=868f6bda&"
import script from "./LocaisSepultamento.vue?vue&type=script&lang=js&"
export * from "./LocaisSepultamento.vue?vue&type=script&lang=js&"
import style0 from "./LocaisSepultamento.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports